import React from 'react';

const CustomerRelations = () => {
  return (
    <div className="customer-relations">
      <div className="page-header">
        <h2>Müşteri İlişkileri</h2>
        <p>Müşteri ilişkilerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default CustomerRelations; 